import axios from 'axios'

export default {
    reportBug(payload) {
        return axios.post('/support/report-bug', payload)
    },
}
